const pagination = {
  data() {
    return {
      pageNo: 1,
      pageSize: 20,
      totalAmount: 0,
      fetchDataHandlerName: null,
    }
  },

  computed: {
    // 总页数
    totalPages() {
      return Math.ceil(this.totalAmount / this.pageSize)
    },
  },

  methods: {
    /**
     * 初始化 List
     * @param fetchDataHandler 组件自身定义的获取后端数据的方法名称
     * @param [doFetch] 是否需要立即请求数据，默认：是
     * 业务组件自定义该函数，方便传递不同的参数，也方便处理不同的 loading 效果
     */
    initPagination(fetchDataHandler, doFetch = true) {
      if (doFetch) {
        this[fetchDataHandler]()
      }

      // 存储获取数据的方法名称
      this.fetchDataHandlerName = fetchDataHandler
    },

    // 翻页操作后获取数据：组件如需自定义，可覆盖
    handlePageNoChange() {
      if (this.fetchDataHandlerName) {
        this[this.fetchDataHandlerName]()
      }
    },
  },
}

export default pagination
